<template>
    <div>

            <vue-headful title="Role Request :: MeritEHS" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/profile`">
                            <i class="fa fa-user"></i> My Profile
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Role Request</li>
                </ol>
            </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header"><strong>Select Roles </strong></div>
                        <div class="card-body">
                            <div class="alert alert-info">
                                This will email all admins on your account with the roles you are requesting.
                            </div>
                            <b-table striped hover bordered small :items="roles" :fields="roleFields">
                                <template #cell(id)="data">
                                    <template v-if="data.item.hasRole == 1">
                                        <span class="text-success" title="You already have this role">Granted</span>
                                    </template>
                                    <template v-else>
                                        <b-form-checkbox v-model="newRoles" :key="data.item.id" :value="data.item.id" plain></b-form-checkbox>
                                    </template>
                                </template>
                                <template #cell(permissions)="data">
                                    <b-button variant="link" @click="data.toggleDetails">{{ data.detailsShowing ? 'Hide' : 'Show' }} Permissions <i :class="`fa fa-caret-${data.detailsShowing ? 'up' : 'down'}`"></i></b-button>
                                </template>
                                <template #row-details="data">
                                    <ul>
                                        <li v-for="perm in data.item.permissions">{{ perm.name }}</li>
                                    </ul>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="requestRoles()" :disabled="saving">Request Roles</button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                errors: {},
                roles: [],
                roleFields: ['id', 'name', 'permissions'],
                newRoles: [],
            }
        },

        computed: {

        },

        methods: {
            //Get the Various Resources We Need to Edit an User
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getRoles: function() {
                //Get the data
                this.$http
                    .get('profile/request-roles')
                    .then(response => {
                        //Set all the data
                        this.roles = response.data.roles;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            requestRoles: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('profile/request-roles', {roles: this.newRoles})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Roles Requested');

                    //Return to main list?
                    this.$router.push('/profile');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getRoles();
        }
    }
</script>
